import { Component, OnInit } from '@angular/core';

import { Http } from '@angular/http';
import { RequestOptions } from '@angular/http';
import { Injectable } from '@angular/core';
import { Headers } from '@angular/http';
import { Locale } from './../../service/locale.service';

@Component({
  selector: 'app-modal-confirm',
  templateUrl: './confirmModal.component.html',
  styleUrls: ['./confirmModal.component.css']
})
export class ConfirmModalComponent {

    public visible = false;
    public visibleAnimate = false;

    private title = "";
    private messages = [];

    private mode = "YES_NO_CANCEL";

    private visibleYesButton = true;
    private visibleNoButton = true;
    private visibleCancelButton = true;
    private yesFunction = function(){};
    private noFunction = function(){};
    private cancelFunction = function(){};

    constructor(private locale: Locale) {}

    /**
     * Imposta il modo.
     * Scegliere tra YES_CANCEL NO_CANCEL YES_NO YES_NO_CANCEL
     */
    public setMode(mode){
      this.mode = mode;
      if (mode.indexOf("YES")!=-1){
        this.visibleYesButton = true;
      }
      else{
        this.visibleYesButton = false;
      }
      if (mode.indexOf("NO")!=-1){
        this.visibleNoButton = true;
      }
      else{
        this.visibleNoButton = false;
      }
      if (mode.indexOf("CANCEL")!=-1){
        this.visibleCancelButton = true;
      }
      else{
        this.visibleCancelButton = false;
      }
    }

    /**
     * Imposta la funzione nel caso in cui l'utente prema si
     */
    public setYesCallback (yesFunction){
      this.yesFunction = yesFunction;
    }

    /**
     * Imposta la funzione nel caso in cui l'utente prema no
     */
    public setNoCallback (noFunction){
      this.noFunction = noFunction;
    }

    /**
     * Imposta la funzione nel caso in cui l'utente prema cancel
     */
    public setCancelCallback (cancelFunction){
      this.cancelFunction = cancelFunction;
    }

    public show() {
        this.visible = true;
        setTimeout(() => this.visibleAnimate = true,100);
    }

    public hide() {
        this.visibleAnimate = false;
        setTimeout(() => this.visible = false,100);
    }

    /**
     * Metodo per impostare il titolo del modale
     * @param title Stringa contentenete il titolo
     */
    public setTitle(title){
      this.title = title;
    }

    /**
     * Metodo per impostare i messaggi che si vogliono stampare nel modale
     * @param title Array che contiene una serie di messaggi che verranno mostrati uno sotto l'altro
     */
    public setMessages (messages){
      this.messages = messages;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/MODAL-confirmModal/confirmModal.component.ts